import PuzzleLogo from '../../assets/puzzlefeeicon.png';
import { HStack } from '../HStack';
import { Text } from '../Text';

type PaidByPuzzleProps = {
  fontColor?: 'white' | 'black';
};

export const PaidByPuzzle = ({ fontColor = 'black' }: PaidByPuzzleProps) => {
  return (
    <HStack className='items-center gap-2'>
      <img src={PuzzleLogo} width={14} height={14} className='rounded-full' />
      <Text color={fontColor}>Paid by Puzzle</Text>
    </HStack>
  );
};

type PaidByPuzzleProProps = {
  fontFamily?: 'space';
  fontColor?: 'white' | 'aqua' | 'black';
};

export const PaidByPuzzlePro = ({
  fontFamily,
  fontColor = 'black',
}: PaidByPuzzleProProps) => {
  return (
    <HStack className='items-center gap-2'>
      <Text family={fontFamily} color={fontColor} font='sm'>
        Covered by
      </Text>
      <Text
        className='rounded-full bg-secondary-yellow px-2 py-0.5'
        font='xs'
        family={fontFamily}
      >
        PRO
      </Text>
    </HStack>
  );
};

type FreeWithPuzzleProProps = {
  onGetProClicked?: () => void;
  fontFamily?: 'space' | 'atak';
  fontColor?: 'white' | 'aqua' | 'black';
};

export const FreeWithPuzzlePro = ({
  onGetProClicked,
  fontFamily = 'atak',
  fontColor = 'black',
}: FreeWithPuzzleProProps) => {
  return (
    <HStack className='items-center gap-2'>
      <Text family={fontFamily} color={fontColor}>
        Free with
      </Text>
      <div onClick={onGetProClicked}>
        <Text
          className={`rounded-full bg-secondary-yellow px-1 py-0.5 ${
            onGetProClicked ? 'cursor-pointer' : ''
          }`}
          font='sm'
          family={fontFamily}
        >
          PRO
        </Text>
      </div>
    </HStack>
  );
};
